import script from "./ValueEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ValueEdit.vue?vue&type=script&setup=true&lang=js"

import "./ValueEdit.vue?vue&type=style&index=0&id=29438ba8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29438ba8"]])

export default __exports__